
<div class="sales-search-view">
  <header>
    <a href="https://www.cardladder.com">
      <full-logo pro />
    </a>

    <btn as="a" kind="secondary" @click="$router.push({ path: '/login', query: $route.query })">
      Login
    </btn>
  </header>

  <div class="container">
    <div v-show="sales.length">
      <h2 class="secondary-font">
        {{ sales.length }} Most Recent {{ sales.length === 1 ? 'Sale' : 'Sales' }}
      </h2>
    </div>

    <spinner v-if="!loaded" />

    <div v-else class="results">
      <empty-state
        v-if="showEmptyState"
        icon="search_off"
        title="There are no results for your query"
      />

      <template v-else>
        <div class="list">
          <sales-list-item
            v-for="(item, i) in sales"
            :key="i"
            as="a"
            :item="item"
            :href="item.url"
            target="_blank"
          >
            <align small-gap>
              <verified-icon v-if="item.cardId || item.memberVerified" />
            </align>
          </sales-list-item>
        </div>
      </template>
    </div>

    <section v-if="loaded" class="upsell">
      <div class="text-upsell">
        <h3 class="secondary-font">
          Wanna see more results?
        </h3>

        <p>Get the estimated price for any card that sold in the past by simply searching for the card in our massive database. Our software can also identify the price relationship between the card and the player's index on that date and use it to forecast the card's current value.</p>

        <div class="button-upsell">
          <div>
            <btn as="a" @click="$router.push({ path: '/signup', query: $route.query })">
              Upgrade to Card Ladder Pro
            </btn>

            <div>
              <small>with a 7-day free trial</small>
            </div>
          </div>
        </div>
      </div>

      <img src="@/assets/upsell-sales-history.png" />
    </section>
  </div>
</div>
